import React, {createContext, useMemo, useState} from 'react';
import AuthenticationService from "service/AuthenticationService";
import {getSessionAttribute, setSessionAttribute} from "../../../utils/SessionUtils";
import {ACCOUNTS_OPTIONS, ACCOUNTS_OPTIONS_NO_SWAP, LEGAL_ENTITY, SELECTED_ACCOUNT, SELECTED_ENTITY} from "../../../utils/Constants";

const initialEntityAccounts = {
    managerId: '',
    managerName: '',
    accountId: '',
    accountName: '',
    accountCode: null,
    formErrors: {search: {}},
    showAccounts: true,
    disableAccounts : false,
    validateAccount:true,
    holidayException: false
};

export const Context = createContext({})
export const Provider = props => {
    const {children} = props;

    const [entityAccountsOptions, setEntityAccountsOptions] = useState(getSessionAttribute(ACCOUNTS_OPTIONS) ?? []);
    const [entityAccountsOptionsNoSwap, setEntityAccountsOptionsNoSwap] = useState(getSessionAttribute(ACCOUNTS_OPTIONS_NO_SWAP) ?? []);
    const [accountsOptions, setAccountsOptions] = useState([]);
    const [accountsOptionsNoSwap, setAccountsOptionsNoSwap] = useState([]);
    const [entityAccounts, setEntityAccounts] = useState(JSON.parse(JSON.stringify(initialEntityAccounts)));
    const [entityAccountsNoSwap, setEntityAccountsNoSwap] = useState(JSON.parse(JSON.stringify(initialEntityAccounts)));
    const getMemoizedEntityAccounts = useMemo(() => AuthenticationService.getEntityAccounts(),[]);
    const getMemoizedEntityAccountsNoSwap = useMemo(() => AuthenticationService.getEntityAccountsNoSwap(),[]);

    const setInitEntityAccountsOptions = (hideSwapLob) => {
        if (hideSwapLob) {
           const EntityAccountsOptionsNoSwap = JSON.parse(JSON.stringify(getMemoizedEntityAccountsNoSwap))
           setEntityAccountsOptionsNoSwap(EntityAccountsOptionsNoSwap);
           setSessionAttribute(ACCOUNTS_OPTIONS_NO_SWAP, EntityAccountsOptionsNoSwap);

        }
        else 
        {
           const EntityAccountsOptions = JSON.parse(JSON.stringify(getMemoizedEntityAccounts))
           setEntityAccountsOptions(EntityAccountsOptions);
           setSessionAttribute(ACCOUNTS_OPTIONS, EntityAccountsOptions);
        }
    }

    const loadAccountOptionsOnManagerChange = (managerId, hideSwapLob) => {

        let accountsForEntity = getAccountsForSelectedEntity(managerId, hideSwapLob);
        if (accountsForEntity) {
            const availableAccountsOptions = JSON.parse(JSON.stringify(accountsForEntity))
            if (hideSwapLob) {
                setAccountsOptionsNoSwap(availableAccountsOptions);
            }
            else 
            {
                setAccountsOptions(availableAccountsOptions);
            }
            
            return availableAccountsOptions.length;
        } else {
            if (hideSwapLob) {
                setAccountsOptionsNoSwap([]);
            }
            else 
            {
                setAccountsOptions([]);
            }
        }

        return 0;
    }

    const getAccountsForSelectedEntity = (selectedManagerId, hideSwapLob) => {
       // let selectedEntity = entityAccountsOptions.find(getEntityForId);
        let managerAccounts;
        if (hideSwapLob){
            managerAccounts = entityAccountsOptionsNoSwap.find(({ managerId }) => managerId.toString() === selectedManagerId.toString());
        } 
        else 
        {
            managerAccounts = entityAccountsOptions.find(({ managerId }) => managerId.toString() === selectedManagerId.toString());
        }
        
        if (managerAccounts) {
            return managerAccounts.accounts;
        }
        return null;
    };


    const getHolidayExceptionForGivenMgrAcct = (selectedManagerId, selectedAccountId, hideSwapLob) => {
        // let selectedEntity = entityAccountsOptions.find(getEntityForId);
        if(selectedManagerId){
            let managerAccounts;
            if (hideSwapLob) {
                managerAccounts = entityAccountsOptionsNoSwap.find(({ managerId }) => managerId.toString() === selectedManagerId.toString());
            }
            else {
                managerAccounts = entityAccountsOptions.find(({ managerId }) => managerId.toString() === selectedManagerId.toString());
            }
            if (selectedAccountId && managerAccounts) {
                let accountDetails = managerAccounts?.accounts.find(({ accountId }) => accountId.toString() === selectedAccountId.toString());
                return accountDetails?.holidayException??false;
            }
            return managerAccounts?.holidayException??false;
        }
        return false;
    };


    const setManagerDetails = (managerId, managerName, hideSwapLob) => {
        const newEntityAccounts = JSON.parse(JSON.stringify((hideSwapLob)?entityAccountsNoSwap:entityAccounts));
        newEntityAccounts.managerId = managerId;
        newEntityAccounts.managerName = managerName;
        newEntityAccounts['formErrors']['search']['entity'] = '';
        newEntityAccounts.accountId = '';
        newEntityAccounts.accountName = '';
        newEntityAccounts.accountCode = null;
        newEntityAccounts.holidayException = false;
       loadAccountOptionsOnManagerChange(managerId, hideSwapLob);
       if (hideSwapLob) {
            setEntityAccountsNoSwap(newEntityAccounts);
       }
       else 
       {
           setEntityAccounts(newEntityAccounts);
       }
       
    };

    const setManagerDetailsWithOptionalAccount = (managerId, managerName, flag, hideSwapLob) => {
        const newEntityAccounts = JSON.parse(JSON.stringify((hideSwapLob)?entityAccountsNoSwap:entityAccounts));
        newEntityAccounts.managerId = managerId;
        newEntityAccounts.managerName = managerName;
        newEntityAccounts.showAccounts = flag;
        newEntityAccounts['formErrors']['search']['entity'] = '';

        loadAccountOptionsOnManagerChange(managerId,hideSwapLob);
        if (hideSwapLob) {
            setEntityAccountsNoSwap(newEntityAccounts);
        } else {
            setEntityAccounts(newEntityAccounts);
        }

    };

    const setAccountDetails = (accountId, accountName, accountCode, hideSwapLob, holidayException=false) => {
        let newEntityAccounts ;
        if (hideSwapLob) {
            newEntityAccounts = {...entityAccountsNoSwap};
        } else {
            newEntityAccounts = {...entityAccounts};
        }
        newEntityAccounts.accountId = accountId;
        newEntityAccounts.accountName = accountName;
        newEntityAccounts.accountCode = accountCode;
        newEntityAccounts.holidayException = holidayException;
        newEntityAccounts['formErrors']['search']['account'] = '';

        if (hideSwapLob) {
            setEntityAccountsNoSwap(newEntityAccounts);
        } else {
            setEntityAccounts(newEntityAccounts);
        }
    };

    const clearAccountDetails = (hideSwapLob) => {
        let newEntityAccounts

        if (hideSwapLob) {
              newEntityAccounts = {...entityAccountsNoSwap};
        } else {
              newEntityAccounts = {...entityAccounts};
        }
        
        newEntityAccounts.accountId = '';
        newEntityAccounts.accountName = '';
        newEntityAccounts.accountCode = null;
        newEntityAccounts.holidayException = false;
        newEntityAccounts['formErrors']['search']['account'] = '';

        if (hideSwapLob) {
              setEntityAccountsNoSwap(newEntityAccounts);
        } else {
              setEntityAccounts(newEntityAccounts);
        }        
    };

    //setManagerAndAccountDetails can be used to set the entity and account selections outside without using EntityAccountsComponent.
    const setManagerAndAccountDetails = (managerId, managerName, accountId, accountName, accountCode, showAccounts, hideSwapLob, holidayException=false) => {
        let nextEntityAccounts = JSON.parse(JSON.stringify((hideSwapLob)?entityAccountsNoSwap:entityAccounts));

        nextEntityAccounts.managerId = managerId;
        nextEntityAccounts.managerName = managerName;
        nextEntityAccounts.accountId = accountId;
        nextEntityAccounts.accountName = accountName;
        nextEntityAccounts.accountCode = accountCode;
        nextEntityAccounts.holidayException = holidayException;
        nextEntityAccounts['formErrors']['search']['entity'] = '';
        nextEntityAccounts['formErrors']['search']['account'] = '';
        nextEntityAccounts.showAccounts = showAccounts;

        if(showAccounts) {
            if(loadAccountOptionsOnManagerChange(managerId, hideSwapLob) === 0){
                nextEntityAccounts.accountId = '';
                nextEntityAccounts.accountName = '';
                nextEntityAccounts.accountCode = null;
                nextEntityAccounts.holidayException = false;
            }
        }
        loadAccountOptionsOnManagerChange(managerId, hideSwapLob)

        if (hideSwapLob) {
           setEntityAccountsNoSwap(nextEntityAccounts);
        } else {
           setEntityAccounts(nextEntityAccounts);
        }

        let correspondingEntity
        
        if (hideSwapLob) {
            correspondingEntity =  getMemoizedEntityAccountsNoSwap.find((entity) => entity.managerId === managerId);
        } else {
            correspondingEntity =  getMemoizedEntityAccounts.find((entity) => entity.managerId === managerId);
        }

        const accountLegalEntityValue = correspondingEntity?.accounts.find((account) => account.accountId === accountId)?.legalEntity;
        if (accountLegalEntityValue) {
            setSessionAttribute(SELECTED_ACCOUNT, {accountId: accountId, name: accountName, accountCode: accountCode, holidayException: holidayException});
            setSessionAttribute(LEGAL_ENTITY,accountLegalEntityValue)
        }

        if (correspondingEntity) {
            const selectedEntity = {}
            selectedEntity['managerId'] = correspondingEntity['managerId'];
            selectedEntity['managerName'] = correspondingEntity['shortName'] + '-' + correspondingEntity['longName'];
            setSessionAttribute(SELECTED_ENTITY, selectedEntity);
        }
    }

    
    const setShowAccounts = (flag, hideSwapLob) => {
        if (hideSwapLob) {
            setEntityAccountsNoSwap({...entityAccountsNoSwap, ['showAccounts']:flag, ['validateAccount']:true});
        } else {
            setEntityAccounts({...entityAccounts, ['showAccounts']:flag, ['validateAccount']:true});
        }
        
    };

    const setDisableAccount = (flag, hideSwapLob) => {
        let savedEntityAccounts
        if (hideSwapLob) {
           savedEntityAccounts = {...entityAccountsNoSwap};
        } else {
           savedEntityAccounts = {...entityAccounts};
        }
        
        savedEntityAccounts.showAccounts = true;
        if (hideSwapLob) {
            setEntityAccountsNoSwap({...savedEntityAccounts, ['disableAccounts']:flag});
        } else {
            setEntityAccounts({...savedEntityAccounts, ['disableAccounts']:flag});
        }
    };

    const setShowAccountValidateAccount = (showFlag,validateAccountFlag, hideSwapLob) => {
        if (hideSwapLob) {
            setEntityAccountsNoSwap({...entityAccountsNoSwap, ['showAccounts']:showFlag ?? true, ['validateAccount']:validateAccountFlag ?? true});    
        } else {
            setEntityAccounts({...entityAccounts, ['showAccounts']:showFlag ?? true, ['validateAccount']:validateAccountFlag ?? true});    
        }
    };

    const clearEntityAccounts = (showAccountFlag, validateAccountFlag, hideSwapLob) => {
        setSessionAttribute(SELECTED_ENTITY, null);
        setSessionAttribute(SELECTED_ACCOUNT, null);
        let hideSwapLobVar = true
        if (hideSwapLob === undefined) {
            hideSwapLobVar = false
        }
        setInitEntityAccountsOptions(hideSwapLobVar);
        populateDefaultEntity(true, hideSwapLobVar)
        if (showAccountFlag !== undefined)
            setShowAccounts(showAccountFlag, hideSwapLobVar);
        if (validateAccountFlag !== undefined)
            setShowAccountValidateAccount(showAccountFlag, validateAccountFlag, hideSwapLobVar);
    };

    const validateEntityAccountSearch = (accountMandatory=true, hideSwapLob) => {
        let errors = {}
        if (hideSwapLob) {
            if (!entityAccountsNoSwap.managerId || entityAccountsNoSwap.managerId === '') {
                errors['entity'] = 'Please select entity'
            }

            if((entityAccountsNoSwap.showAccounts && entityAccountsNoSwap.validateAccount && !entityAccountsNoSwap.disableAccounts) && !entityAccountsNoSwap.accountId && accountMandatory){
                errors['account'] = 'Please select account'
            }

            const newFormErrors = {...entityAccountsNoSwap.formErrors}
            newFormErrors['search'] = errors;
            entityAccounts.formErrors = newFormErrors;
            setEntityAccountsNoSwap(entityAccountsNoSwap);
        } else {
            if (!entityAccounts.managerId || entityAccounts.managerId === '') {
                errors['entity'] = 'Please select entity'
            }

            if((entityAccounts.showAccounts && entityAccounts.validateAccount && !entityAccounts.disableAccounts) && !entityAccounts.accountId && accountMandatory){
                errors['account'] = 'Please select account'
            }

            const newFormErrors = {...entityAccounts.formErrors}
            newFormErrors['search'] = errors;
            entityAccounts.formErrors = newFormErrors;
            setEntityAccounts(entityAccounts);
        }
        return errors;
    };

    const validateEntitySearch = (hideSwapLob) => {
        let errors = {}
        if (hideSwapLob) {
            if (!entityAccountsNoSwap.managerId || entityAccountsNoSwap.managerId === '') {
                errors['entity'] = 'Please select entity'
            }

            const newFormErrors = {...entityAccountsNoSwap.formErrors}
            newFormErrors['search'] = errors;
            entityAccountsNoSwap.formErrors = newFormErrors;
            setEntityAccountsNoSwap(entityAccountsNoSwap);
        } else {
            if (!entityAccounts.managerId || entityAccounts.managerId === '') {
                errors['entity'] = 'Please select entity'
            }

            const newFormErrors = {...entityAccounts.formErrors}
            newFormErrors['search'] = errors;
            entityAccounts.formErrors = newFormErrors;
            setEntityAccounts(entityAccounts);
        }
        return errors;
    };

    const paramBadgeInfo = (hideSwapLob) => {
        let badgeInfo='';
        if (hideSwapLob) {
            if(entityAccountsNoSwap.accountCode === null || entityAccountsNoSwap.accountCode === ''){
                badgeInfo = 'ALL'
            }
            else {
                badgeInfo = !!entityAccountsNoSwap.accountCode? entityAccountsNoSwap.accountCode + '-'+entityAccountsNoSwap.accountName:entityAccountsNoSwap.accountName
            }
        } else {
            if(entityAccounts.accountCode === null || entityAccounts.accountCode === ''){
                badgeInfo = 'ALL'
            }
            else {
                badgeInfo = !!entityAccounts.accountCode? entityAccounts.accountCode + '-'+entityAccounts.accountName:entityAccounts.accountName
            }
        }
        return badgeInfo
    }

    const isSelectedEntityInTheList = (selectedEntity, hideSwapLob) => {
        let result = false
        if (selectedEntity) {
            if (hideSwapLob === true) {
                if(entityAccountsOptionsNoSwap && entityAccountsOptionsNoSwap.length > 0){
                    result = entityAccountsOptionsNoSwap.findIndex(item=> item.managerId === selectedEntity.managerId)>=0
                }
            }else {
                if(entityAccountsOptions && entityAccountsOptions.length > 0){
                    result = entityAccountsOptions.findIndex(item=> item.managerId === selectedEntity.managerId)>=0
                }
            }
        }
        return result
    }
    const populateDefaultEntity = (flag, hideSwapLob) => {
        const selectedEntityFromSession = getSessionAttribute(SELECTED_ENTITY);
        const selectedAccountFromSession = getSessionAttribute(SELECTED_ACCOUNT);
        const selectedEntityInList = isSelectedEntityInTheList(selectedEntityFromSession, hideSwapLob);

        if(selectedEntityFromSession !== null && selectedAccountFromSession !== null && selectedEntityInList === true){
            setManagerAndAccountDetails(selectedEntityFromSession.managerId, selectedEntityFromSession.managerName, selectedAccountFromSession.accountId, selectedAccountFromSession.name, selectedAccountFromSession.accountCode, flag, hideSwapLob, selectedAccountFromSession.holidayException);
            return
        }
        if(selectedEntityFromSession !== null && selectedEntityInList === true){
            setManagerDetailsWithOptionalAccount(selectedEntityFromSession.managerId, selectedEntityFromSession.managerName, flag,hideSwapLob);
            setSessionAttribute(SELECTED_ACCOUNT, {accountId: '', name: '', accountCode: null, holidayException: false});
            return
        }
        // with the default first position of entity
            if (hideSwapLob) {
                if(entityAccountsOptionsNoSwap && entityAccountsOptionsNoSwap.length > 0) {
                    setManagerDetailsWithOptionalAccount(entityAccountsOptionsNoSwap[0].managerId, entityAccountsOptionsNoSwap[0].shortName+"-"+entityAccountsOptionsNoSwap[0].longName, flag,hideSwapLob)
                    setSessionAttribute(SELECTED_ENTITY, {managerId:entityAccountsOptionsNoSwap[0].managerId, managerName: entityAccountsOptionsNoSwap[0].shortName+"-"+entityAccountsOptionsNoSwap[0].longName});
                    setSessionAttribute(SELECTED_ACCOUNT, {accountId: '', name: '', accountCode: null, holidayException: false});
                    if (entityAccountsOptionsNoSwap[0].accounts && entityAccountsOptionsNoSwap[0].accounts.length > 0) {
                        setSessionAttribute(LEGAL_ENTITY,entityAccountsOptionsNoSwap[0].accounts[0]?.legalEntity);
                    }
                }
            } else {
                if(entityAccountsOptions && entityAccountsOptions.length > 0) {
                    setManagerDetailsWithOptionalAccount(entityAccountsOptions[0].managerId, entityAccountsOptions[0].shortName+"-"+entityAccountsOptions[0].longName, flag,hideSwapLob)
                    setSessionAttribute(SELECTED_ENTITY, {managerId:entityAccountsOptions[0].managerId, managerName: entityAccountsOptions[0].shortName+"-"+entityAccountsOptions[0].longName});
                    setSessionAttribute(SELECTED_ACCOUNT, {accountId: '', name: '', accountCode: null, holidayException: false});
                    if (entityAccountsOptions[0].accounts && entityAccountsOptions[0].accounts.length > 0) {
                        setSessionAttribute(LEGAL_ENTITY,entityAccountsOptions[0].accounts[0]?.legalEntity);
                    }
                }
            }
    }

    const entityAccountsContext = {
        entityAccountsOptions,
        setEntityAccountsOptions,
        entityAccountsOptionsNoSwap,
        setEntityAccountsOptionsNoSwap,
        accountsOptions,
        accountsOptionsNoSwap,
        entityAccounts,
        entityAccountsNoSwap,
        setEntityAccounts,
        setEntityAccountsNoSwap,
        setAccountsOptions,
        setAccountsOptionsNoSwap,
        getAccountsForSelectedEntity,
        setManagerDetailsWithOptionalAccount,
        setManagerDetails,
        setAccountDetails,
        setManagerAndAccountDetails,
        setShowAccounts,
        clearEntityAccounts,
        validateEntityAccountSearch,
        validateEntitySearch,
        setShowAccountValidateAccount,
        setDisableAccount,
        clearAccountDetails,
        setInitEntityAccountsOptions,
        paramBadgeInfo,
        populateDefaultEntity,getMemoizedEntityAccounts,
        getMemoizedEntityAccountsNoSwap, getHolidayExceptionForGivenMgrAcct,
        loadAccountOptionsOnManagerChange
    }
    return <Context.Provider value={entityAccountsContext}>
        {children}
    </Context.Provider>

}
export const {Consumer} = Context;
